package tta.destinigo.talktoastro.feature_profile.chat_history.data.response

data class ExpertDetails(
    val id: String,
    val name: String,
    val image: String,
    val skills: String
)

